import React from 'react'

export default function PageNotFound() {
  return (
<div className="loading">
        <h1 className="header ">404 Page not found </h1>
      </div>
  )
}
